import { MakeName } from "@/types/make";

export const paths = {
  home: {
    path: "/",
    getHref: () => "/",
  },
  auth: {
    login: {
      path: "/auth/login",
      getHref: (redirectTo?: string) =>
        `/auth/login${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ""}`,
    },
    passwordRecover: {
      path: "/auth/password-recovery",
      getHref: () => "/auth/password-recovery",
    },
    setNewPasswordRecover: {
      path: "/auth/recover-password/:registration_token",
      getHref: (registration_token: string, email: string) =>
        `/auth/recover-password/${registration_token}?user=${encodeURIComponent(email)}`,
    },
    activation: {
      path: "/auth/activation",
      getHref: (registration_token: string, email: string, hostname = window.location.origin) =>
        `${hostname}/auth/activation/${registration_token}?user=${encodeURIComponent(email)}`,
    },
    signUp: {
      path: "/auth/sign-up",
      getHref: () => "/auth/sign-up",
    },
  },
  plans: {
    root: {
      path: "plans",
      getHref: () => "/plans",
    },
  },
  app: {
    root: {
      path: "/app",
      getHref: () => "/app",
    },
    dashboard: {
      path: "",
      getHref: () => "/app",
    },
    garage: {
      root: {
        path: "garages/:garageId",
        getHref: (garageId?: string) => `/app/garages${garageId ? `/${garageId}` : ""}`,
      },
      car: {
        path: "cars/:carId",
        getHref: (garageId: string, carId?: string) =>
          `/app/garages/${garageId}/cars${carId ? `/${carId}` : ""}`,
      },
    },
    compare: {
      path: "compare/:car1Id/:car2Id/:car3Id?",
      getHref: (car1Id: string, car2Id: string, car3Id?: string) =>
        `/app/compare/${car1Id}/${car2Id}${car3Id ? `/${car3Id}` : ""}`,
    },
    markets: {
      root: {
        path: "markets",
        getHref: () => "/app/markets",
      },
      makes: {
        path: "markets/makes",
        getHref: () => "/app/markets/makes",
      },
      makeDetails: {
        path: "markets/makes/:makeId",
        getHref: (makeId: MakeName) => `/app/markets/makes/${makeId}`,
      },
      car: {
        path: "markets/cars/:carId",
        getHref: (carId: string) => `/app/markets/cars/${carId}`,
      },
      compare: {
        path: "markets/compare/:car1Id/:car2Id/:car3Id?",
        getHref: (car1Id: string, car2Id: string, car3Id?: string) =>
          `/app/markets/compare/${car1Id}/${car2Id}${car3Id ? `/${car3Id}` : ""}`,
      },
    },
    auction: {
      root: {
        path: "auctions",
        getHref: () => "/app/auctions",
      },
      details: {
        path: ":auctionId",
        getHref: (auctionId: string) => `/app/auctions/${auctionId}`,
      },
    },
    vin: {
      car: {
        path: "vin/:carId",
        getHref: (carId: string) => {
          // Ensure route params are safe for path segments (e.g. "ABC/123" -> "ABC%2F123")
          // and avoid double-encoding if callers already encoded the value.
          let decoded = carId;
          try {
            decoded = decodeURIComponent(carId);
          } catch {
            decoded = carId;
          }
          return `/app/vin/${encodeURIComponent(decoded)}`;
        },
      },
    },
    documents: {
      path: "documents",
      getHref: () => "/app/documents",
    },
    profile: {
      path: "profile",
      getHref: () => "/app/profile",
    },
    components: {
      // Debug url
      path: "components",
      getHref: () => "/app/components",
    },
    formerCars: {
      root: {
        path: "former-cars",
        getHref: () => "/app/former-cars",
      },
      car: {
        path: ":carId",
        getHref: (carId: string) => `/app/former-cars/${carId}`,
      },
    },
  },
} as const;
